import { LineBreakTransformer } from "./LineBreakTransformer";
import { ParsedWeightData, Weighbridge } from "./Weighbridge";

export class DiniArgeoWeighbridge implements Weighbridge {
    public baudRate: number = 9600;
    public lineBreakSeparator: string = '\r\n';
    public lineBreakTransformer?: LineBreakTransformer;

    public parse(buffer: string): ParsedWeightData {
        const modes = [buffer.slice(0, 2), buffer.slice(3, 5)];
        const weight = parseInt(buffer.slice(6, 14));
        const unit = buffer.slice(15, 17);

        return {
            modes,
            weight,
            unit,
        };
    }

    public getLineBreakTransformer() {
        return this.lineBreakTransformer ??= new LineBreakTransformer(this.lineBreakSeparator);
    }
}